module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('div', {
    staticClass: "mb10"
  }, [_c('el-button', {
    staticClass: "mb10",
    attrs: {
      "type": "primary",
      "size": "normal"
    },
    on: {
      "click": _vm.toCert
    }
  }, [_vm._v("运动员备案\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "mb10",
    attrs: {
      "type": "primary",
      "size": "normal"
    },
    on: {
      "click": _vm.toApply
    }
  }, [_vm._v("能力测试申报\n      ")])], 1), _vm._v(" "), _c('el-table', {
    ref: "table",
    attrs: {
      "data": _vm.list,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "报名会议",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v(_vm._s(scope.row.danwei))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.num))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(scope.row.saiqu_name))]), _vm._v(" "), _c('p', [_vm._v("人数:" + _vm._s(scope.row.member_count))]), _vm._v(" "), _c('p', [_vm._v("联系人:" + _vm._s(scope.row.ldname) + " 电话:" + _vm._s(scope.row.phone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.memberstatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "default"
          }
        }, [_vm._v("\n            完善人员信息\n          ")]) : (scope.row.memberstatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "default"
          }
        }, [_vm._v("\n            完成联系人信息\n          ")]) : (scope.row.memberstatus == 6) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n            报名成功\n          ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n          " + _vm._s(_vm._f("timeFormat")(scope.row.create_time)) + "\n        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.toMember(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.memberstatus == 6 ? '查看人员' : '完善人员'))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-pagination"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "current-page": parseInt(_vm.row.currentpage),
      "page-size": _vm.params.pageSize,
      "layout": "total, prev, pager, next",
      "total": _vm.row.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '85%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("运动员技术等级申报")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "所属年份"
    },
    on: {
      "click": function($event) {
        _vm.showOldGradePicker = true
      }
    },
    model: {
      value: (_vm.formData.year),
      callback: function($$v) {
        _vm.$set(_vm.formData, "year", $$v)
      },
      expression: "formData.year"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showOldGradePicker),
      callback: function($$v) {
        _vm.showOldGradePicker = $$v
      },
      expression: "showOldGradePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.oldGradeColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showOldGradePicker = false
      },
      "confirm": _vm.onOldGradeConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "所属地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "单位全称",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "联络人",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "身份证照片",
      "value": _vm.formData.shenfenzheng_pic.length + '/2'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.shenfenzheng_pic,
      "limit": 2,
      "name": 'shenfenzheng_pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传身份证正面、背面照片")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "联系电话",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入联系电话"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '微信不能为空'
      }],
      "error-message-align": "right",
      "label": "微信",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入微信"
    },
    model: {
      value: (_vm.formData.weixin),
      callback: function($$v) {
        _vm.$set(_vm.formData, "weixin", $$v)
      },
      expression: "formData.weixin"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '地址不能为空'
      }],
      "error-message-align": "right",
      "label": "邮寄地址",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮寄地址"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "人员选择",
      "placeholder": "请选择人员"
    },
    on: {
      "click": function($event) {
        _vm.showYundongyuanPicker = true
      }
    }
  }), _vm._v(" "), _c('YundongyuanPicker', {
    attrs: {
      "show": _vm.showYundongyuanPicker,
      "limit": 30,
      "defaultValue": _vm.formData.yundongyuan
    },
    on: {
      "onChange": _vm.onYundongyuanChange,
      "onClose": function($event) {
        _vm.showYundongyuanPicker = false
      },
      "onConfirm": _vm.onYundongyuanConfirm
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formData.yundongyuan.length > 0),
      expression: "formData.yundongyuan.length>0"
    }],
    staticClass: "memberResultWrap"
  }, _vm._l((_vm.formData.yundongyuan), function(yundongyuan, index) {
    return _c('div', {
      staticClass: "memberLi"
    }, [_c('van-tag', {
      key: index,
      attrs: {
        "round": "",
        "color": "#fff",
        "text-color": "#666",
        "size": "large",
        "closeable": "",
        "type": "primary"
      },
      on: {
        "close": function($event) {
          return _vm.formData.yundongyuan.splice(index, 1)
        }
      }
    }, [_vm._v(" " + _vm._s(yundongyuan.name) + "(" + _vm._s(yundongyuan.num) + ") " + _vm._s(yundongyuan.project) + "-" + _vm._s(yundongyuan.grade) + "\n                ")])], 1)
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("保存\n            ")])], 1)], 1)], 1)]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b1e607a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyList.vue
// module id = 1533
// module chunks = 0